import { render, staticRenderFns } from "./contentResetPassword.vue?vue&type=template&id=191a2284&"
import script from "./contentResetPassword.vue?vue&type=script&lang=js&"
export * from "./contentResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports